/* eslint-disable  @typescript-eslint/no-explicit-any */
import bg from '@Common/i18n/locales/bg_BG.json'; // Bulgarian
import cs from '@Common/i18n/locales/cs_CZ.json'; // Czech
import da from '@Common/i18n/locales/da_DK.json'; // Danish
import de from '@Common/i18n/locales/de_DE.json';
import el from '@Common/i18n/locales/el_GR.json'; // Greek
import en from '@Common/i18n/locales/en.json';
import es from '@Common/i18n/locales/es_ES.json';
import fi from '@Common/i18n/locales/fi_FI.json'; // Finnish
import fr from '@Common/i18n/locales/fr_FR.json';
import hr from '@Common/i18n/locales/hr_HR.json'; // Croatian
import hu from '@Common/i18n/locales/hu_HU.json'; // Hungarian
import it from '@Common/i18n/locales/it_IT.json';
import lt from '@Common/i18n/locales/lt_LT.json'; // Lithuanian
import lv from '@Common/i18n/locales/lv_LV.json'; // Latvian
import pl from '@Common/i18n/locales/pl_PL.json';
import pt from '@Common/i18n/locales/pt_PT.json'; // Portuguese
import ro from '@Common/i18n/locales/ro_RO.json'; // Romanian
import sk from '@Common/i18n/locales/sk_SK.json'; // Slovak
import sl from '@Common/i18n/locales/sl_SI.json'; // Slovenian
import sv from '@Common/i18n/locales/sv_SE.json'; // Swedish

export interface Values {
  [key: string]: any;
}

export enum AVAILABLE_LOCALES {
  En = 'en',
  Fr = 'fr',
  Pl = 'pl',
  Es = 'es',
  De = 'de',
  It = 'it',
  Sv = 'sv',
  Lv = 'lv',
  Lt = 'lt',
  Pt = 'pt',
  Ro = 'ro',
  Sk = 'sk',
  Sl = 'sl',
  Cs = 'cs',
  Bg = 'bg',
  Hr = 'hr',
  Da = 'da',
  Fi = 'fi',
  El = 'el',
  Hu = 'hu',
}

export type LocaleKey = `${AVAILABLE_LOCALES}`;
export type Locale = keyof typeof en;

export const localesEnabledOnProd: AVAILABLE_LOCALES[] = [
  AVAILABLE_LOCALES.En,
  AVAILABLE_LOCALES.Fr,
];

export const locales: Record<AVAILABLE_LOCALES, Partial<Record<Locale, string>>> = {
  [AVAILABLE_LOCALES.En]: en,
  [AVAILABLE_LOCALES.Fr]: fr,
  [AVAILABLE_LOCALES.Pl]: pl,
  [AVAILABLE_LOCALES.Es]: es,
  [AVAILABLE_LOCALES.De]: de,
  [AVAILABLE_LOCALES.It]: it,
  [AVAILABLE_LOCALES.Sv]: sv,
  [AVAILABLE_LOCALES.Lv]: lv,
  [AVAILABLE_LOCALES.Lt]: lt,
  [AVAILABLE_LOCALES.Pt]: pt,
  [AVAILABLE_LOCALES.Ro]: ro,
  [AVAILABLE_LOCALES.Sk]: sk,
  [AVAILABLE_LOCALES.Sl]: sl,
  [AVAILABLE_LOCALES.Cs]: cs,
  [AVAILABLE_LOCALES.Bg]: bg,
  [AVAILABLE_LOCALES.Hr]: hr,
  [AVAILABLE_LOCALES.Da]: da,
  [AVAILABLE_LOCALES.Fi]: fi,
  [AVAILABLE_LOCALES.El]: el,
  [AVAILABLE_LOCALES.Hu]: hu,
};

export const localesFileMapping: Record<AVAILABLE_LOCALES, string> = {
  [AVAILABLE_LOCALES.En]: 'en',
  [AVAILABLE_LOCALES.Fr]: 'fr_FR',
  [AVAILABLE_LOCALES.Pl]: 'pl_PL',
  [AVAILABLE_LOCALES.Es]: 'es_ES',
  [AVAILABLE_LOCALES.De]: 'de_DE',
  [AVAILABLE_LOCALES.It]: 'it_IT',
  [AVAILABLE_LOCALES.Sv]: 'sv_SE',
  [AVAILABLE_LOCALES.Lv]: 'lv_LV',
  [AVAILABLE_LOCALES.Lt]: 'lt_LT',
  [AVAILABLE_LOCALES.Pt]: 'pt_PT',
  [AVAILABLE_LOCALES.Ro]: 'ro_RO',
  [AVAILABLE_LOCALES.Sk]: 'sk_SK',
  [AVAILABLE_LOCALES.Sl]: 'sl_SI',
  [AVAILABLE_LOCALES.Cs]: 'cs_CZ',
  [AVAILABLE_LOCALES.Bg]: 'bg_BG',
  [AVAILABLE_LOCALES.Hr]: 'hr_HR',
  [AVAILABLE_LOCALES.Da]: 'da_DK',
  [AVAILABLE_LOCALES.Fi]: 'fi_FI',
  [AVAILABLE_LOCALES.El]: 'el_GR',
  [AVAILABLE_LOCALES.Hu]: 'hu_HU',
};

export type TFunctionType = (id: Locale, values?: Values) => string;
